/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Temporisationsummermode2Inputs */



/**
* | output |
* | --- |
* | "Summer mode temporization" |
*
* @param {Br_History_Key_Temporisationsummermode2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_temporisationsummermode2 = /** @type {((inputs?: Br_History_Key_Temporisationsummermode2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Temporisationsummermode2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer mode temporization")
	return /** @type {LocalizedString} */ ("Temporisation mode été")
});
export { br_history_key_temporisationsummermode2 as "br_history_key_temporisationSummerMode" }